import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Drive, Drives } from "./types.js";
addProp(_User, "drive", Drive);
addProp(_User, "drives", Drives);
//# sourceMappingURL=users.js.map